module.exports = __webpack_public_path__ + "img/buddy_ears-03.79695874.svg";